import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import { rootReducer } from './rootReducer';

const middleware = applyMiddleware(promise(), thunk);
const store = createStore(rootReducer, composeWithDevTools(middleware));
export default store;



// WEBPACK FOOTER //
// ./src/store/configureStore.js